export default class Stream {
    public roles: {id: string}[] = [];
    constructor() {}
}